import { useSearchParams } from "react-router-dom";

export function useSelectedParam() {
	const [searchParams, setSearchParams] = useSearchParams();

	const selectedParam = searchParams.get("selected");

	const parsed = selectedParam ? parseSelected(selectedParam) : null;

	const openSelected = (taskId: number, subtaskId?: number, tagId?: number) => {
		const tag = tagId ?? 0;
		const selected = subtaskId ? `M-${tag}-${taskId}-US${subtaskId}` : `M-${tag}-${taskId}`;

		setSearchParams((prev) => {
			const next = new URLSearchParams(prev);

			next.set("selected", selected);

			return next;
		});
	};

	const closeSelected = () => {
		setSearchParams((prev) => {
			const next = new URLSearchParams(prev);

			next.delete("selected");

			return next;
		});
	};

	return { parsed, openSelected, closeSelected };
}

function parseSelected(selected: string) {
	const subtaskMatch = selected.match(/^M-(\d+)-(\d+)-US(\d+)$/);

	if (subtaskMatch) {
		return {
			tagId: +subtaskMatch[1],
			taskId: +subtaskMatch[2],
			subtaskId: +subtaskMatch[3],
		};
	}

	const taskMatch = selected.match(/^M-(\d+)-(\d+)$/);

	if (taskMatch) {
		return {
			tagId: +taskMatch[1],
			taskId: +taskMatch[2],
			subtaskId: null,
		};
	}

	return null;
}
